export default __webpack_public_path__ + "static/media/new-defiLogo.d15b9460.png";